import React from 'react';
import { Group } from '../../../../../../redux/groups/api/group.model';
import { Merchandiser } from '../../../../redux/composableDevice/model/Merchandiser.model';
import {
  Box,
  darken,
  lighten,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { IncidentAPIResponseMVP } from '../../../../../../redux/incident/api/Incident.model';
import { getPolyglot } from '../../../../../../i18n';
import InfoCard from '../../InfoCard/InfoCard';
import { AlarmIcon } from '../../../../../../theme/icons';

const StoreOverviewCard = (props: {
  city: Group;
  merchandisers: Merchandiser[];
  alarms: IncidentAPIResponseMVP[];
}) => {
  const { city, merchandisers, alarms } = props;
  const polyglot = getPolyglot();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const error = alarms.length > 0;

  return (
    <InfoCard
      infoTitle={city.name}
      subtitle={
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-evenly',
            background: error
              ? theme.palette.error.light
              : theme.palette.neutral?.main,
            padding: '0.3rem 1rem',
          }}
        >
          <Typography
            variant="h6"
            color={error ? 'error.main' : 'common.black'}
            sx={{ flex: '1 1 0' }}
          >
            {polyglot.t('freshwatch.dashboard.merchandisers')}
          </Typography>
          {error ? (
            <Typography
              variant="h6"
              color={error ? 'error.main' : 'common.black'}
              sx={{ flex: '1 1 0' }}
            >
              {polyglot.t('freshwatch.dashboard.alarms')}
            </Typography>
          ) : null}
        </Box>
      }
      error={error}
      sx={{
        width: '100%',
        maxWidth: isMobile ? '100%' : '300px',
        boxShadow: 2,
        cursor: 'default',
      }}
      disableRipple={true}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          height: '80px',
          justifyContent: 'space-evenly',
          background: error
            ? theme.palette.error.contrastText
            : theme.palette.common.white,
          padding: '0 1rem',
        }}
      >
        <Typography
          fontSize={'2.5rem'}
          color={error ? 'error.main' : 'common.black'}
          variant="h4"
          sx={{ flex: '1 1 0' }}
        >
          {merchandisers.length}
        </Typography>
        {error ? (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flex: '1 1 0',
            }}
          >
            <AlarmIcon height={'2rem'} color={theme.palette.error.main} />
            <Typography
              sx={{ padding: '0 0 0 0.2rem' }}
              fontSize={'2.5rem'}
              color={error ? 'error.main' : 'common.black'}
              variant="h4"
            >
              {alarms.length}
            </Typography>
          </Box>
        ) : null}
      </Box>
    </InfoCard>
  );
};
export default StoreOverviewCard;
